import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from '../_EditorHelp/_EditorHelp';

import styles from './TwoThirdsOneThird.module.css';

export default function TwoThirdsOneThird(props: ComponentProps): JSX.Element {
	const isEditing = IsSitecoreEditing();
	const hasTwoThirdsContent = props.rendering.placeholders?.['rcnlearn-twothirds']?.length ?? 0 > 0;
	const hasOneThirdContent = props.rendering.placeholders?.['rcnlearn-onethird']?.length ?? 0 > 0;

	if (!hasTwoThirdsContent && !hasOneThirdContent && !isEditing) {
		return <></>;
	}

	return (
		<>
			<EditorHelp text="Two Thirds One Third START" indent color={'blue'} />
			<section
				className={`${styles.grid} ${!isEditing ? styles.gridNotEditing : styles.gridEditing} pad maxWidth`}
				data-display-pdf-download
			>
				<div className={`${isEditing ? styles.flexEditing : styles.flex} pad maxWidth`}>
					<Placeholder name="rcnlearn-twothirds" rendering={props.rendering} />
				</div>
				<div className={`${isEditing ? styles.flexEditing : styles.flex} pad maxWidth`}>
					<Placeholder name="rcnlearn-onethird" rendering={props.rendering} />
				</div>
			</section>
			<EditorHelp text="Two Thirds One Third END" indent color={'blue'} />
		</>
	);
}
